import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CustomersService } from 'src/app/services/core/services/customers/customers.service';
import { InvoiceService } from 'src/app/services/core/services/invoices/invoice.service';
import { NUMBER_OF_RECORDS, INVOICE_STATUS_STAT_CARDS, INVOICE_AMOUNT_STAT_CARDS, toInvoiceRow } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
import { debounceTime, filter, Subject } from 'rxjs';
import * as moment from 'moment';

@UntilDestroy()

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {
  
  invoices:any = [];
  filterInvices:any;
   totalPages = 0;
  totalResults = 0;
  search: any = '';
  private searchSubject = new Subject<string>();
  currentPage: number = 1;
  invoiceDetail:any;
  selectedCompanyId = null;
  selectedCustomerId = null;
  selectedStatus = '';
  invoiceDateRange: any = [moment().startOf('day').toDate(), moment().endOf('day').toDate()];
  stats: any = {};
  statusStatCards = INVOICE_STATUS_STAT_CARDS;
  amountStatCards = INVOICE_AMOUNT_STAT_CARDS;
  companies:any;
  customers: any;
  loadingId = null;
  syncType = null;
  selectedDropdownId:any;
  toggleActionButtons = false;

  numberOfRecords = NUMBER_OF_RECORDS;

  constructor(
    private companyService  : CompanyService,
    private customersService: CustomersService,
    private invoiceService : InvoiceService,
    private router: Router
  ){}

  ngOnInit(): void {
    this.getCompanies();
    this.initializeSearch();
    this.getInvoielist(this.currentPage);
  }

  getInvoielist(page: any) {
    const queryParams: any = {
      limit: this.numberOfRecords,
      page,
    }
    if (this.search) {
      queryParams.search = this.search.trim();
    }
    if (this.selectedCompanyId) {
      queryParams.company = this.selectedCompanyId;
    }
    if (this.selectedCustomerId) {
      queryParams.customer = this.selectedCustomerId;
    }
    if (this.selectedStatus) {
      queryParams.status = this.selectedStatus;
    }
    const dates = this.invoiceDateQuery();
    if (dates.startDate) {
      queryParams.startDate = dates.startDate;
      queryParams.endDate = dates.endDate;
    }
    this.invoiceService.getInvoice(queryParams).pipe(untilDestroyed(this)).subscribe({
      next: (data:any)=>{
        if(data){
          const { data: rows = [], overview = {} } = (data?.[0] || {}) as any;
          this.invoices = (rows || []).map(toInvoiceRow);
          this.filterInvices = [...this.invoices];
          this.totalPages = overview.totalPages;
          this.totalResults = overview.totalResults;
          this.stats = overview;
        }
      },
      error: (err) => {
        sweetAlert('Error', err, 'error', 'Ok');
      }
    })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getInvoielist(page);
  }

onDownlaodInvoice(companyId: any, invoiceId: any) {
  this.invoiceService.getInvoicePDf(companyId, invoiceId).subscribe((data:any) => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `invoice-${invoiceId}.pdf`;
    a.click();

    window.URL.revokeObjectURL(url);
  }, err => {
    sweetAlert("Error", err, "error", "Ok");
  });
}



  opendetailModal(item: any) {
    this.invoiceDetail = item;
  }

  getCompanies() {
    this.companyService.getCompanies().pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.companies = data.results
        // this.preCompanies = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  onCompanyFilterChange() {
    this.selectedCustomerId = null;
    this.customers = null;
    this.currentPage = 1;
    if (this.selectedCompanyId) {
      this.getCustomers();
    }
    this.getInvoielist(this.currentPage);
  }

  onCustomerFilterChange() {
    this.currentPage = 1;
    this.getInvoielist(this.currentPage);
  }

  onStatusFilterChange() {
    this.currentPage = 1;
    this.getInvoielist(this.currentPage);
  }

  onInvoiceDateChange(event: any) {
    if (!event?.[0] && !event?.[1]) {
      this.invoiceDateRange = null;
      this.currentPage = 1;
      this.getInvoielist(this.currentPage);
      return;
    }
    if (!event?.[0] || !event?.[1]) {
      return;
    }
    this.invoiceDateRange = event;
    this.currentPage = 1;
    this.getInvoielist(this.currentPage);
  }

  invoiceDateQuery() {
    if (!this.invoiceDateRange?.[0] || !this.invoiceDateRange?.[1]) {
      return {};
    }
    return {
      startDate: moment(this.invoiceDateRange[0]).format('YYYY-MM-DD'),
      endDate: moment(this.invoiceDateRange[1]).format('YYYY-MM-DD'),
    };
  }

  getCustomers() {
    this.customersService.getCustomers({
      limit: 9999,
      company: this.selectedCompanyId
    }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.customers = (data.results || []).filter((customer: any) => customer.Id)
      }
    })
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3),
        untilDestroyed(this)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getInvoielist(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  async onSyncInvoice(invoice: any, type: any) {
    const mPull = 'Are you sure you want to overwrite invoice data with QuickBooks data?';
    const mPush = 'Are you sure you want to overwrite the QuickBooks data with invoice data';
    const result = await sweetAlert('Alert', type === 'pull' ? mPull : mPush, 'warning', 'Yes', 'No');
    if (!result.value) return;

    this.loadingId = invoice.id;
    this.syncType = type;
    if (type === 'pull') invoice.pulling = true; else invoice.pushing = true;
    this.closeActionMenu(null);
    this.invoiceService.syncInvoice(invoice.company.id, invoice.id, { isSyncFrom: type === 'pull' }).subscribe(
      {
        next: (data: any) => {
          this.getInvoielist(this.currentPage);
          sweetAlert('Success', data?.message || 'Synced successfully', 'success', 'Ok');
        },
        error: (err) => {
          sweetAlert('Error', err, 'error', 'Ok');
          invoice.pulling = false;
          invoice.pushing = false;
          this.loadingId = null;
          this.syncType = null;
        },
        complete: () => {
          invoice.pulling = false;
          invoice.pushing = false;
          this.loadingId = null;
          this.syncType = null;
        }
      })
  }

  async onDeleteInvoice(compamyId: any, invoiceId: any) {
    const result = await sweetAlert('Alert', 'Are you sure you want to delete this invoice?', 'warning', 'Yes', 'No');
    if (!result.value) return;
    this.closeActionMenu(null);
    this.invoiceService.deleteInvoice(compamyId, invoiceId).subscribe(
      {
        next: (data) => {
          this.getInvoielist(this.currentPage);
        },
        error: (err) => {
          sweetAlert("Error", err, "error", "Ok");
          this.loadingId = null;
        },
        complete: () => {
          
        }
      })
  }

  onSendEmail(compamyId: any, invoiceId: any) {
    
    this.invoiceService.sendEmail(compamyId, invoiceId).subscribe(
      {
        next: (data) => {
          
        },
        error: (err) => {
          sweetAlert("Error", err, "error", "Ok");
          this.loadingId = null;
        },
        complete: () => {
          
        }
      })
  }

  showActionButtons(id:any) {
    this.selectedDropdownId = id;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownId = null;
    this.toggleActionButtons = false;
  }

  openReceivePayment(invoiceId: any) {
    this.router.navigateByUrl(`/invoices/${invoiceId}/receive-payment`);
  }

}
